/* Success Screen Component */
import React from 'react';
import { formatTime } from '../utils/date-helpers-consolidated';
import { useNavigate } from 'react-router';



interface SuccessScreenProps {
  data: any;
}
const SuccessScreen = ({  data }:SuccessScreenProps) => {
  const { action, timestamp, location } = data;
  const nav = useNavigate();
  // Determine success message based on action type
  let actionText = '';
  let iconClass = '';
  
  if (action.includes('sign-in')) {
    actionText = 'Signed In';
    iconClass = 'success-icon-in';
  } else {
    actionText = 'Signed Out';
    iconClass = 'success-icon-out';
  }
  
  return (
    <div className="success-screen">
      <div className={`success-icon ${iconClass}`}>
        {action.includes('sign-in') ? '✓' : '✓'}
      </div>
      
      <h2 className="success-title">{actionText} Successfully!</h2>
      
      <div className="success-details">
        <div className="success-detail">
          <span className="detail-label">Time:</span>
          <span className="detail-value">{formatTime(timestamp)}</span>
        </div>
        
        <div className="success-detail">
          <span className="detail-label">Location:</span>
          <span className="detail-value">{location}</span>
        </div>
        
        {data.name && (
          <div className="success-detail">
            <span className="detail-label">Name:</span>
            <span className="detail-value">{data.name}</span>
          </div>
        )}
        
        {data.destination && (
          <div className="success-detail">
            <span className="detail-label">Destination:</span>
            <span className="detail-value">{data.destination}</span>
          </div>
        )}
      </div>
      
      <button className="success-button" onClick={() => nav('/')}>
        Done
      </button>
    </div>
  );
};

export default SuccessScreen;